import Aion from '@adoratorio/aion'

const loop = new Aion({ autostop: false })

export default loop



// WEBPACK FOOTER //
// ./src/scripts/loop.js